import React from 'react';
import { Card } from 'react-bootstrap';
import  { useDispatch, useSelector } from 'react-redux'
import { Button } from 'react-bootstrap';
import { Modal, Table } from 'react-bootstrap';
import { useState }  from 'react';
import FalconCloseButton from 'components/common/FalconCloseButton';
import { useForm, Controller } from 'react-hook-form'
import { updateSelezioneAmbiti } from '../reduxStore/questCorrenteSlice.js'
import { FcCancel } from "react-icons/fc";
import { FcOk } from "react-icons/fc";

const SelezioneAmbiti = () => {

// ----------------------------------------------------------
//  INIZIO GESTIONE Modal
  const [modalShow, setModalShow] = useState(false);

  const handleOpenModal = () => {
    setModalShow(true)
  }

  const handleCloseModal = () => {
    setModalShow(false)
  }
//  FINE GESTIONE Modal
// ----------------------------------------------------------

// ----------------------------------------------------------
  // estraggo array ambiti da questionarioCorrente:
  const questionarioCorrente = useSelector((state) => state.questCorrente);
  const ambitiArray = questionarioCorrente.ambiti

  console.log(ambitiArray)
// ----------------------------------------------------------


//  INIZIO GESTIONE PER react-hook-form
    const dispatch = useDispatch();
    const { control, handleSubmit } = useForm({
      defaultValues: {
        ambiti: ambitiArray.map(({ key, classe, descrizione, enabled }) => ({ key, classe, descrizione, enabled }))
      }
    });
  
    const onSubmit = (data) => {
      // console.log(data);
      const updatedValues = {
          questionarioUuid: questionarioCorrente.questionarioUuid, 
          ambitiArray: data
      }
      console.log('Selezione Ambiti - updatedValues: ', updatedValues)
      
      dispatch(updateSelezioneAmbiti(updatedValues)) 
      setModalShow(false)
    };
//  FINE GESTIONE PER react-hook-form



  return (
    <Card className="text-left">
      <Card.Body className="p-5">
        <h1 className="text-center">
          <strong>Selezione aziendale ambiti principali</strong>
        </h1>

        <hr />
    <Button variant="primary" onClick={handleOpenModal}>
      Modifica selezione ambiti
    </Button>
    <hr />
    <Table className="fs-10 mt-3">
          <tbody>
            {ambitiArray.map((ambito) => (
              <tr
                key={ambito.key}
                className="align-middle white-space-nowrap"
              >
                <td key="classe" className="fs-10 text-900">
                  {ambito.classe}
                </td>
                <td key="key" className="fs-10 text-900">
                  {ambito.key}
                </td>
                <td key="enabled" className="fs-10 text-900">
                  {(ambito.enabled)?<FcOk />:<FcCancel />}
                </td>
                <td key="descrizione" className="fs-10 text-900">
                  {ambito.descrizione}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <hr />
        <Modal size="lg" show={modalShow} onHide={handleCloseModal} backdrop="static" keyboard={false}>
          <Modal.Header>
            <Modal.Title>Seleziona Ambiti</Modal.Title>
            <FalconCloseButton onClick={handleCloseModal}/>
          </Modal.Header>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Modal.Body>
              <Table className="fs-10 mt-3">
                <tbody>
                  {ambitiArray.map((ambito, index) => (
                    <tr key={ambito.key} className="align-middle white-space-nowrap">
                      <td className="fs-10 text-900">{ambito.classe}</td>
                      <td className="fs-10 text-900">{ambito.key}</td>
                      <td className="fs-10 text-900">{ambito.descrizione}</td>
                      <td>
                        <Controller
                          name={`ambiti[${index}].enabled`}
                          control={control}
                          render={({ field }) => (
                            <input type="checkbox" {...field} checked={field.value} />
                          )}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseModal}>Annulla</Button>
              <Button variant="primary" type="submit">Invia</Button>
            </Modal.Footer>
          </form>
        </Modal>
      </Card.Body>
    </Card>
  );
};

export default SelezioneAmbiti;
